<navbar [title]=""></navbar>
<router-outlet></router-outlet>
<footer></footer>
